import React, { useCallback } from 'react';
import Button from '../../../components/Button/Button';
import { t } from '../../../i18n';
import s from '../WatchtowerPage.module.scss';
import { useMap } from '../../../components/Map/MapContext';
import { useFlowmap } from '../FlowmapContext';

const ClearAll = ({ onClick, zoomToWorld }) => {
    const { countryList } = useMap();
    const { showFlowmap, activeFilterCount } = useFlowmap();

    const hasActiveCountry = Boolean(countryList?.activeCountryCode);
    const shouldDisplay =
        showFlowmap || activeFilterCount > 0 || hasActiveCountry;

    const handleClick = useCallback(() => {
        countryList?.onCountryClick?.(null);
        if (typeof zoomToWorld === 'function') {
            zoomToWorld();
        }
        onClick?.();
    }, [countryList, onClick, zoomToWorld]);

    if (!shouldDisplay) {
        return null;
    }

    return (
        <div className={s.LayerPicker}>
            <Button
                title={t('watchtowerPage.clearAll')}
                modifier="Dark"
                extraClasses={[s.ClearAllButton]}
                onClick={handleClick}
            />
        </div>
    );
};

export default ClearAll;
